var map = {
	"./en/strings.js": "D/sH",
	"./fr/strings.js": "DX2N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "apj+";


//////////////////
// WEBPACK FOOTER
// ./src/lang \.js$
// module id = apj+
// module chunks = 3